import { render, staticRenderFns } from "./BalancoEnergeticoStats.vue?vue&type=template&id=502b14fa&scoped=true"
import script from "./BalancoEnergeticoStats.vue?vue&type=script&lang=js"
export * from "./BalancoEnergeticoStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b14fa",
  null
  
)

export default component.exports